import ButterImage from '../../components/ButterImage'

export type BulletHeroProps = {
  readonly title: string
  readonly description?: string
  readonly bulletPoints: ReadonlyArray<{
    readonly title: string
    readonly description?: string
    readonly image: string
    readonly imageDescription: string
    readonly bullet_size: 'small' | 'medium'
  }>
}

/**
 * This component renders a hero with a title, description and a list of bullets.
 * @param bulletPoints list of bullets to render
 * @param description description to render
 * @param title title to render
 */
export default function BulletHero({ bulletPoints, description, title }: BulletHeroProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <h2>{title}</h2>
      <p>{description}</p>
      <div
        style={{
          display: 'grid',
          gridColumn: 'min-content min-content min-content',
          gridAutoFlow: 'column',
          gap: '50px',
        }}
      >
        {bulletPoints.map(({ image, imageDescription, title, description, bullet_size }) => (
          <div
            key={title}
            style={{
              maxWidth: '500px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <ButterImage
              src={image}
              height={bullet_size === 'small' ? 60 : 100}
              width={bullet_size === 'small' ? 60 : 100}
              alt={imageDescription}
            />
            <h3>{title}</h3>
            <p style={{ textAlign: 'center' }}>{description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
